import * as React from "react";
import Container from "react-bootstrap/Container";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import "./addAppliance.scss";
import dayjs from "dayjs";
import { errorToast, successToast } from "../../common/ToastMessage";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import ClearIcon from '@mui/icons-material/Clear';
import FormHelperText from '@mui/material/FormHelperText';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Loader from "../../common/Loader";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#e5f0fb',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function EditAppliance() {
  const navigate = useNavigate();
  const params = useParams();
  const current = new Date();
  const [error, setError] = useState([]);
  const [purchasedate, setdateValue] = React.useState(current);
  const [appliancecode, setApplianceCode] = useState("");
  const [applianceID, setApplianceID] = useState("");
  const [brandname, setBrandName] = useState("");
  const [appliancename, setApplianceName] = useState("");
  const [vendorname, setVendorname] = React.useState("");
  const [image, setImage] = useState([]);
  const [warrantyperiod, setWarrantyPeriod] = React.useState("");
  const [vendor, setVendor] = useState();
  const [brands, setBrands] = useState();
  const [category, setCategory] = useState([]);
  const [vendornumber, setVendorNumber] = useState("");
  const [preview, setPreview] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const hiddenFileInput = React.useRef(null);
  const [isActive, setLoaderActive] = useState(false);

  const headers = {
    Authorization: "Bearer " + localStorage.getItem("_token"),
    "Content-type": "application/json",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getCategoryData();
    getApplianceDataByID();
    getvendor();
    getBrandName();
  }, [params?.id]);

  const getApplianceDataByID = async () => {
    setLoaderActive(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/ApplianceGetById?id=${params?.id}`,
        {
          headers: headers,
        }
      );
      const resData = response?.data?.data?.[0];
      setdateValue(resData?.purchaseDate);
      setApplianceCode(resData?.applianceCode);
      setBrandName(resData?.brandId);
      setApplianceID(resData?.categoryId);
      setApplianceName(resData?.categoryId)
      let viewImg =
        resData?.applianceImage !== undefined ? resData?.applianceImage : [];
      setImage(viewImg);
      setFileCount(viewImg[0]?.applianceImageId === 0 ? 0 : viewImg.length);
      setVendorname(resData?.supplierId);
      setWarrantyPeriod(resData?.warrantPeriod);
      setVendorNumber(resData?.supplierNumber);
      setLoaderActive(false);

    }
    catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };
  function editApplianceData() {
    if (validateForm()) {
      setLoaderActive(false);
      let item = {
        applianceId: params?.id,
        categoryId: applianceID,
        applianceCode: appliancecode,
        brandid: brandname,
        PruchaseDate: purchasedate,
        warrantPeriod: warrantyperiod,
        VendorId: vendorname,
      };

      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/Update`,
          item,
          {
            headers: headers,
          }
        )
        .then(function (response) {
          console.log("response:::", response?.status);

          if (response?.status == "200") {
            setLoaderActive(false);
            navigate("/appliances")
            successToast(response?.data?.message)
          }
        })
        .catch(function (error) {
          console.log("error", error);
          setLoaderActive(false);
          if (error?.response?.status === 401) {
            errorToast(error?.response?.statusText)
          } else {
            errorToast(error?.message)
          }
        });
    }
  }

  const getvendor = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor`,
        {
          headers: headers,
        }
      );
      setVendor(response.data.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const getVendornumber = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor/GetByID`,
        {
          headers: headers,
          params: {
            id: id,
          },
        }
      );
      setVendorNumber(response?.data?.data?.[0]?.supplierNumber);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const getBrandName = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/GetBrandName`,
        {
          headers: headers,
        }
      );
      setBrands(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryData = async () => {
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/CategoryDetails`,
      {
        headers: headers,
      }
    ).then((response) => {
      if (response?.status == 200) {
        setCategory(response?.data?.data);
      }
    }).catch((error) => {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    });
  };

  const handleClick = event => {
    hiddenFileInput.current.click();

  };

  const handleInputChange = (e) => {
    let data = new FormData();
    Array.from(e.target.files).forEach((img) => {
      data.append("ApplianceImage", img);
      data.append("ApplianceId", params?.id);
    });
    insertImage(data)
  };
  const insertImage = (data) => {
    const headers2 = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/InsertImages`,
        data,
        {
          headers: headers2,
        }
      )
      .then(function (response) {
        if (response?.status == "200") {
          successToast(response?.data?.message)
          getApplianceDataByID()
        }
      })
      .catch(function (error) {
        console.log("error", error);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  }
  const removeImage = (imgID) => {
    const headers2 = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/DeleteImages`,
        imgID,
        {
          headers: headers2,
        }
      )
      .then(function (response) {
        if (response?.status == "200") {
          successToast(response?.data?.message)
          getApplianceDataByID()
        }
      })
      .catch(function (error) {
        console.log("error", error);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  }
  const handleDelete = (applianceImageID) => {
    removeImage([applianceImageID]);
  }
  const renderPhotos = (source) => {
    return Array?.from(source).map((ele, index) => {
      return (
        ele?.applianceImageId !== 0 ?
          <div key={`image-edit-${index + 1}`} className='image-preview-div'>
            <img
              src={ele?.applianceImage}
              alt={"logo"}
              className="image-preview-img"
              key={ele?.applianceImage}
              onClick={() => {
                setPreview(true);
              }}
            />
            <ClearOutlinedIcon onClick={() => handleDelete(ele?.applianceImageId)} style={{ float: "right" }} />
          </div> : null
      );
    });
  };
  const handleChange = (newValue) => {
    setError([]);
    setdateValue(dayjs(newValue).format());
  };
  const handleClose = () => {
    navigate("/appliances");
  };

  const handleChangeSupplierId = (event) => {
    setError([]);
    setVendorname(event.target.value);
    getVendornumber(event.target.value);
  };

  const validateForm = () => {
    setError([]);
    let error = {};

    if (!appliancecode) {
      error.appliancecode = "Appliance Code is required";
    }
    if (!appliancename) {
      error.appliancename = "Appliance Name is required";
    }
    if (!brandname) {
      error.brandname = "Brand Name is required";
    }
    if (!purchasedate) {
      error.purchasedate = "Purchase Date is required";
    }
    if (!vendorname) {
      error.vendorname = "Vendor Name is required";
    }
    if (!vendornumber) {
      error.vendornumber = "Vendor Number is required";
    }

    if (!warrantyperiod) {
      error.warrantyperiod = "Warranty Period is required";
    }

    if (Object.keys(error).length > 0) {
      setError(error);
      return false;
    }
    return true;
  };
  const getName = (imgURl) => {
    const name = imgURl?.split('/')
    return name[name?.length - 1]
  }
  return (
    <div>
      <Loader isLoading={isActive} />
      <div className="management">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="appliance-wrapper">
                <h5>Edit Appliance</h5>
                <div className="row">
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <TextField
                        fullWidth
                        error={error && error.appliancecode}
                        id="outlined-basic"
                        variant="outlined"
                        label="Appliance Code"
                        value={appliancecode ? appliancecode : ""}
                        onChange={(e) => {
                          setError([]);
                          setApplianceCode(e.target.value);
                        }}
                        helperText={error.appliancecode}
                        placeholder="hint: u2020-Mou-2023"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          error={error && error.appliancename}
                        >
                          Appliance Name
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={applianceID}
                          label="Appliances Name"
                          error={error && error.appliancename}
                          onChange={(e) => {
                            setError([]);
                            setApplianceName(e.target.value)
                            setApplianceID(e.target.value)
                          }}
                          helperText={error.appliancename}
                        >
                          {category &&
                            category?.map((item, index) => {
                              return (
                                <MenuItem value={item?.categoryId}
                                  key={`vendor-view${index + 1}`}
                                >
                                  {item?.categoryName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                      <FormHelperText className="helperTextError">{error.appliancename}</FormHelperText>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          error={error && error.brandname}
                        >
                          Brand Name
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={brandname}
                          label="Brand Name"
                          error={error && error.brandname}
                          onChange={(e) => {
                            setError([]);
                            setBrandName(e.target.value);
                          }}
                          helperText={error.brandname}
                        >
                          {brands &&
                            brands.map((item, index) => {
                              return (
                                <MenuItem value={item?.brandId}
                                  key={`vendor-view${index + 1}`}
                                >
                                  {item?.brandName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                      <FormHelperText className="helperTextError">{error.brandname}</FormHelperText>

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                          error={error && error.purchasedate}
                          label="Purchase Date"
                          id="outlined-basic"
                          variant="outlined"
                          inputFormat="DD/MM/YYYY"
                          value={purchasedate}
                          onChange={(e) => {
                            setError([]);
                            handleChange(e);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                          helperText={error.purchasedate}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Warrant Period"
                        variant="outlined"
                        onChange={(e) => {
                          setError([]);
                          setWarrantyPeriod(e.target.value);
                        }}
                        error={error && error.warrantyperiod}
                        helperText={error.warrantyperiod}
                        value={warrantyperiod ? warrantyperiod : ""}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          error={error && error.vendorname}
                        >
                          Vendor Name
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={vendorname}
                          label="Vendor Name"
                          error={error && error.vendorname}
                          onChange={(e) => {
                            handleChangeSupplierId(e);
                          }}
                          helperText={error.vendorname}
                        >
                          {vendor &&
                            vendor.map((item, index) => {
                              return (
                                <MenuItem
                                  value={item?.supplierId}
                                  key={`vendor-view${index + 1}`}
                                >
                                  {item?.supplierName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    <FormHelperText className="helperTextError">{error.vendorname}</FormHelperText>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        variant="outlined"
                        label={"Vendor Number"}
                        value={vendornumber}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="txtfield-wrap">
                      <div className="">
                        <Button className="fileBtn" onClick={handleClick} >
                          <span className="text-gray m-r-10Per">Choose File</span>
                          <span className="text-gray m-r-auto">{fileCount ? fileCount + " " + "Selected Files" : "No File Choosen "}  </span>
                        </Button>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          id="customFile"
                          name="upload_file"
                          ref={hiddenFileInput}
                          onChange={(e) => {
                            setError([]);
                            handleInputChange(e);
                          }}
                          multiple={true}
                          hidden
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="d-flex">
                      {/* {image?.length ? renderPhotos(image) : null} */}
                      {image?.length && Array.from(image)?.[0]?.applianceImageId !== 0 ?
                        <>
                          <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell>No.</StyledTableCell>
                                  <StyledTableCell>Image</StyledTableCell>
                                  <StyledTableCell>Name</StyledTableCell>
                                  <StyledTableCell>Action</StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Array.from(image).map((row, index) => (
                                  <TableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                      {index + 1}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      <div>
                                        <img
                                          src={row?.applianceImage}
                                          alt={"logo"}
                                          className="table-image"
                                          key={row?.applianceImage}
                                          onClick={() => {
                                            setPreview(true);
                                          }}
                                        />
                                      </div></StyledTableCell>
                                    <StyledTableCell>{getName(row.applianceImage)}</StyledTableCell>
                                    <StyledTableCell><>
                                      <span className="d-flex">
                                        <div
                                          className="edit me-3"
                                          title="View"
                                          onClick={() => setPreview(true)}
                                        >
                                          <VisibilityIcon color="primary" />
                                        </div>
                                        <div
                                          className="edit me-3"
                                          title="Delete"
                                          onClick={() => handleDelete(row?.applianceImageId)}
                                        >
                                          <DeleteRoundedIcon color="error" />
                                        </div>
                                      </span>
                                    </></StyledTableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                        : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="bottom-btn-wrap">
                      <Button
                        onClick={() => editApplianceData()}
                        variant="outlined"
                      >
                        Update
                      </Button>
                      <Button variant="outlined" onClick={() => handleClose()}>
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
            {preview ? (
              <>
                <Modal
                  show={true}
                  centered
                  size="lg"
                  onHide={() => {
                    setPreview(false);
                  }}
                  className="modal-image"
                  fullscreen={true}
                >
                  <ClearIcon style={{ color: "white", cursor: "pointer", fontSize: "40px", left: '96%', position: 'relative' }} onClick={() => setPreview(false)} />
                  <Modal.Body>
                    <Carousel>
                      {image.map((ele, index) => {
                        return (
                          <Carousel.Item key={`image-view-${index + 1}`}>
                            <div key={`image-view-${index + 1}`}>
                              <div className="d-flex align-items-center justify-content-center">
                                <img
                                  src={ele?.applianceImage}
                                  alt={"logo"}
                                  className="modelPreview"
                                  key={ele?.id}
                                />
                              </div>
                            </div>
                          </Carousel.Item>
                        )
                      })}
                    </Carousel>
                  </Modal.Body>
                </Modal>
              </>
            ) : null}
          </main>
        </div>
      </div>
    </div>
  );
}
